import { Draft } from '@reduxjs/toolkit'
import { produce } from 'immer'
import { ObjectsState } from '~/store/objects/reducer'

export const patchupRoofSections = (data: ObjectsState) => {
  return produce(data, (facility: Draft<ObjectsState>) => {
    for (const id in facility.roofSections) {
      const section = facility.roofSections[id]
      if (!section.beamNames) {
        section.beamNames = Array.from(Array(26)).map((_, i) => i.toString())
      }
      if (!section.columnNames) {
        section.columnNames = Array.from(Array(26)).map((_, i) => String.fromCharCode(i + 65))
      }
    }
  })
}
